import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLongEmptyState = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 35,
	height: 9,
	viewBox: "0 0 35 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M34.3536 4.85355C34.5488 4.65829 34.5488 4.34171 34.3536 4.14645L31.1716 0.964466C30.9763 0.769204 30.6597 0.769204 30.4645 0.964466C30.2692 1.15973 30.2692 1.47631 30.4645 1.67157L33.2929 4.5L30.4645 7.32843C30.2692 7.52369 30.2692 7.84027 30.4645 8.03553C30.6597 8.2308 30.9763 8.2308 31.1716 8.03553L34.3536 4.85355ZM34 4L4.37115e-08 4L-4.37115e-08 5L34 5L34 4Z",
		fill: "#6B719D"
	})
});
export default SvgArrowLongEmptyState;
